import React, {Component} from "react";
import {LocalForm, Errors, Control} from "react-redux-form";
import {isRequired, isEmail} from "../field_validations";
import {history} from "../../store/store";

export default class UserLogin extends Component {
	render() {
		return <div className="content">
			<p className="is-size-5 has-text-centered">Iniciar Sesión</p>
			{this.props.error && <p className="has-text-centered help is-danger">{this.props.error}</p>}
			{this.props.message && <p className="has-text-centered help is-success">{this.props.message}</p>}
			{this.props.register.message && <p className="has-text-centered help is-success">{this.props.register.message}</p>}

			<LocalForm onSubmit={(values) => this._handleSubmit(values)}>
				<div className="field">
					<div className="control has-icon has-icon-left">
						<Control.text
							type="email"
							model=".username"
							className="input"
							placeholder="Usuario"
							autoFocus={true}
							validateOn="change"
							errors={{isRequired, isEmail}}
						/>
						<span className="icon is-small is-left">
							<i className={`fa fa-envelope`}/>
						</span>
					</div>
					<Errors
						className="help is-danger"
						model=".username"
						show="touched"
						messages={{
							isRequired: 'Ingresa tu usuario. ',
							isEmail: 'El usuario que ingresaste es inválido. '
						}}
					/>
				</div>
				<div className="field">
					<div className="control has-icon has-icon-left">
						<Control.password
							model=".password"
							className="input"
							placeholder="Contraseña"
							errors={{isRequired}}
						/>
						<span className="icon is-small is-left"><i className={`fa fa-lock`}/></span>
					</div>
					<Errors
						className="help is-danger"
						model=".password"
						show="touched"
						messages={{
							isRequired: 'Ingresa tu contraseña'
						}}
					/>
				</div>

				<div className="level">
					<div className="level-left">
						<div className="level-item">
							<div className="field">
								<div className="control">
									<label htmlFor="remember" className="checkbox">
										<Control.checkbox model=".remember" id="remember" name="remember" />
										Recordarme
									</label>
								</div>
							</div>
						</div>
					</div>
					<div className="level-right">
						<div className="level-item">
							<button className="button is-black">
								<span>Ingresar</span>
								<span className="icon is-small"><i className="fa fa-sign-in"></i></span>
							</button>
						</div>
					</div>
				</div>

			</LocalForm>

			<br/>
			<div className="level">
				<div className="level-left">
					{this.props.register.state === 'open' ?
					<div className="level-item">
						<button
							onClick={() => history.push('/registro')}
							className="button is-small">
							Registrarse
						</button>
					</div>:''}
				</div>

				<div className="level-right">
					<div className="level-item">
						<button
							onClick={() => this.props.setActionType('forgot')}
							className="button is-small">
							¿Olvidaste tu contraseña?
						</button>
					</div>
				</div>
			</div>
		</div>
	}

	_handleSubmit(values) {
		this.props.login(values);
	}
}



// WEBPACK FOOTER //
// ./src/elements/login/userLogin.jsx